module.exports = __webpack_public_path__ + "assets/img/bannerBg2x.e667d9f0.png";